import { render } from "./FormInput.vue?vue&type=template&id=23664296&scoped=true&ts=true"
import script from "./FormInput.vue?vue&type=script&lang=ts"
export * from "./FormInput.vue?vue&type=script&lang=ts"

import "./FormInput.vue?vue&type=style&index=0&id=23664296&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23664296"]])

export default __exports__